import React from 'react';
import Card from '../../UI/Card';
import styled from 'styled-components';
import {fontSize, wh} from '../../mixins';

const StyledIco = styled.img`
  ${wh('45px', 'auto')};
`

const StyledTxt = styled.p`
  margin: 0;
  ${fontSize(14)};
  line-height: 20px;
  color: #323232;
  text-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
`

const RippleCard = () => (
    <>
        <StyledIco src='../images/ripple-img.png'/>
        <StyledTxt>Your Ripple Button device let’s you share your location with family members when SOS button is triggered.</StyledTxt>
    </>
);

export default RippleCard;